import React from 'react';
import { useModal } from 'hooks';
import { Container, Wrapper } from './styles';
import { setModalOpened } from 'store/modal/actions';

interface IProps {
  children?: React.ReactNode;
  closeModalFunction?: Function;
  open?: boolean;
  width?: string;
}

const Modal: React.FC = () => {
  const { children, opened, width, closeModalFunction } = useModal();

  if (!opened) {
    return <></>;
  }

  const handleClose = () => {
    setModalOpened(false);
    if (closeModalFunction) closeModalFunction();
  }

  return (
    <Wrapper onClick={() => handleClose()}>
      <Container width={width} onClick={(event) => event.stopPropagation()}>
        {children}
      </Container>
    </Wrapper>
  );
}

export default Modal;